import { DropdownOptions } from '@/store/campaigns/types';
import { Campaign, CampaignStatus } from '@dev/ee-api/ee-api-models';
import { SimplePopoverPlainOption } from '@dev/ee-components';
import i18n from '@/../i18n';

export const getDropdownTableOptions = (campaign?: Campaign): SimplePopoverPlainOption[] => {
    const statusesWithViewDetails = [
        CampaignStatus.Sending,
        CampaignStatus.Cancelled,
        CampaignStatus.Paused,
        CampaignStatus.Completed,
    ];

    if (!campaign) return [
        {
            label: i18n.t('copycampaign'),
            value: DropdownOptions.CopyCampaign,
        },
        {
            label: i18n.t('delete'),
            color: '#ff0000',
            value: DropdownOptions.Delete,
        }
    ];

    if (statusesWithViewDetails.includes(campaign.Status)) {
        return [
            {
                label: i18n.t('viewreport'),
                value: DropdownOptions.ViewReport,
            },
            {
                label: i18n.t('viewdetails'),
                value: DropdownOptions.ViewDetails,
            },
            {
                label: i18n.t('copycampaign'),
                value: DropdownOptions.CopyCampaign,
            },
            {
                label: i18n.t('delete'),
                color: '#ff0000',
                value: DropdownOptions.Delete,
            }
        ];
    }
    
    // active === scheduled
    if (campaign.Status === CampaignStatus.Active) {
        return [
            {
                label: i18n.t('edit'),
                value: DropdownOptions.Edit,
            },
            {
                label: i18n.t('copycampaign'),
                value: DropdownOptions.CopyCampaign,
            },
            {
                label: i18n.t('delete'),
                color: '#ff0000',
                value: DropdownOptions.Delete,
            }
        ];
    }
};
